<!-- Header HTML Start -->
<!-- HTML Start -->
<!-- Header Start -->
<header class="header-hld header-invison">
    <section class="header-bot">
      <div class="container">
        <div class="row">
          <div class="col-9 ">
            <a href="javascript:void(0)" title="Sanlam" class="logo-hld" [routerLink]="userData!=null?['/portal/home']:['/register']">



                        <app-logo size="large" width="202" height="43" viewBox="0 0 203 44" fill="none"></app-logo>
            </a>
          </div>
          <div class="col-3 text-end d-flex justify-content-end">
            <button (click)="logout()" id='logOutBtn' style="display:none;">Logout</button>
            <button name="Header-Login" title="SanlamLogin" (click)="azureActivelogin()" id="Login_Header" class="loginlink" *ngIf="userData==null">
              <span class="d-md-block d-none" id="Login_Header_Text">Login</span>
              <span class="d-md-none d-block">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 4C12 6.21 10.21 8 8 8C5.79 8 4 6.21 4 4C4 1.79 5.79 0 8 0C10.21 0 12 1.79 12 4ZM0 14C0 11.34 5.33 10 8 10C10.67 10 16 11.34 16 14V16H0V14Z" fill="#8A929C"/>
                  </svg>
              </span>
            </button>

          </div>
        </div>
      </div>
    </section>
  </header>

<!-- Header HTML End -->


<section class="register">
    <div class="container">
        <!-- Reg HTML Start -->

        <div class="login-hld" *ngIf="!signupSuccess">

                <div class="d-flex flex-wrap align-items-stretch">

                    <div class="col-lg-6 col-md-7 regsterfrm px-3">


                        <form  [formGroup]="idNumberForm" (ngSubmit)="idNumberCheck()" id="id-number-form" *ngIf="showDefaultCampaign">
                            <h2 class="mx-md-0 pt-md-0 caption bottomline mt-0"><b class="font-bolder">Register</b> for your Credit Profile</h2>
                            <p class="text-start px-md-0 mt-md-2 mt-0">Provide your 13-digit South African ID number to create a secure login for your FREE Sanlam Credit Dashboard.</p>

                            <div *ngIf="errorMsg!=''" class="alert alert-danger mb-0 mt-4" role="alert" [innerHTML]="errorMsg">
                            </div>
                            <div class="login-bg d-flex flex-wrap">

                                <div class="required mb-md-0 col-md-8 col-12 px-0 inputspcemobile">
                                    <div class="form-field position-relative">

                                        <input id="IdNumber_Registration" type="tel" class="form-control" placeholder="" formControlName="IdNumber"
                                            numeric-field maxlength="13">

                                            <span class="tooltip-wrapper" #tooltipRef (click)="handleClick($event)">
                                                <span class="tooltiptext" [class.show]="isDesktop() || showTooltip">We use your ID number to pull your credit information from the credit bureau into your
                                                    personalised credit dashboard.</span>
                                                <span class="triange-icon" [class.show]="isDesktop() || showTooltip">
                                                    <svg width="33" height="24" viewBox="0 0 33 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <!-- Triangle Fill -->
                                                        <path d="M0.968322 0.955376L31.8333 0.513795L16.7163 22.7499Z" fill="white" />
                                                        <!-- Left Border -->
                                                        <line x1="0.968322" y1="0.955376" x2="16.7163" y2="22.7499" stroke="#D9D9D9" />
                                                        <!-- Right Border -->
                                                        <line x1="31.8333" y1="0.513795" x2="16.7163" y2="22.7499" stroke="#D9D9D9" />
                                                    </svg>
                                                </span>
                                                <span class="tooltip-icon">
                                                    <img ngOptimizedImage src="../../assets/images/info-icon.svg">
                                                </span>
                                            </span>
                                            
                                        <label for="IdNumber">ID Number</label>
                                        <div *ngIf="idNumberFormControls.IdNumber.touched && idNumberFormControls.IdNumber.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="idNumberFormControls.IdNumber.errors.required">ID Number is required</div>
                                            <div *ngIf="idNumberFormControls.IdNumber.errors.minlength">ID Number must be 13 digits long
                                            </div>
                                            <div *ngIf="idNumberFormControls.IdNumber.errors.isValidIdNumber">Please enter your valid 13
                                                digits South
                                                African ID Number</div>
                                        </div>

                                    </div>

                                </div>
                                <div class="col-md-4 col-4 pe-md-0 pe-0 ps-md-3 mt-0 ps-0 mt-md-0">
                                    <button type="submit" class="btnregister w-100 mb-0"
                                            name="btnRegisterRegisterPage" id="Register_Next_btn"
                                            #artcileNudge>
                                        Next
                                    </button>
                                </div>

                                <div class="form-group w-100 pt-3 ps-0 mb-md-3 mb-0  pt-md-4 justify-content-between">

                                    <div class="pt-0 pt-md-0 w-100">
                                        <p class="text-start">Already have an account?
                                            <button type="button" (click)="azureAdlogin(false)" id="Login" name="Body-login" class="login-link">Login
                                            </button>
                                        </p>

                                    </div>
                                </div>
                               
                                <div class="form-group fullwidth w-100 pb-0 mb-3 d-flex align-items-center">

                                    <p class="text-start d-flex align-items-center m-0">

                                        <svg width="24" height="24" viewBox="0 0 12 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.75 6H10.5C11.325 6 12 6.675 12 7.5V15C12 15.825 11.325 16.5 10.5 16.5H1.5C0.675 16.5 0 15.825 0 15V7.5C0 6.675 0.675 6 1.5 6H2.25V4.5C2.25 2.43 3.93 0.75 6 0.75C8.07 0.75 9.75 2.43 9.75 4.5V6ZM6 2.25C4.755 2.25 3.75 3.255 3.75 4.5V6H8.25V4.5C8.25 3.255 7.245 2.25 6 2.25ZM1.5 15V7.5H10.5V15H1.5ZM7.5 11.25C7.5 12.075 6.825 12.75 6 12.75C5.175 12.75 4.5 12.075 4.5 11.25C4.5 10.425 5.175 9.75 6 9.75C6.825 9.75 7.5 10.425 7.5 11.25Z" fill="#0075c9"/>
                                            </svg>


                                        <span class="ps-1 text-blue pt-1">All personal information is secure and confidential.</span>
                                    </p>
                                </div>

                            </div>
                            <figure class="m-0 d-block d-md-none">
                              <div class="bgmg position-relative">
                                  <img ngOptimizedImage  [src]="defaultImage" class="ps-md-5" alt="" *ngIf="!imageUrl"/>
                                  <img ngOptimizedImage  [src]="imageUrl" class="ps-md-5" alt="" *ngIf="imageUrl"/>
                              </div>
                          </figure>


                        @if(isDesktop()) {
                        <div class="whatyouget mt-md-3">
                            <div class="d-flex flex-wrap">
                                <div class="col-md-12 col-12 px-0 center-align">
                                    <h2 class="mb-0 bottomline frequently-questions">Frequently Asked Questions</h2>
                                    <div ngbAccordion [closeOthers]="true">
                                        <div ngbAccordionItem #parentItem="ngbAccordionItem">
                                            <span ngbAccordionHeader id="">
                                                <button type="button"  (click)="parentItem.toggle()" class="accordion-button custom-header"
                                                    [attr.aria-expanded]="!parentItem.collapsed" id=""> <span class="question-mark-icon me-2">
                                                        <img ngOptimizedImage src="../../assets/images/question-mark-icon.svg">
                                                    </span> <b>Why is it important to check your credit profile regularly?</b></button>
                                            </span>
                                            <div ngbAccordionCollapse>
                                                <div ngbAccordionBody>
                                                    <ng-template>
                                                        <p class="text-start d-flex align-items-start text-lg">
                                                            <img height="16" width="20" class="me-2"src="../../assets/images/green-check-icon.png">
                                                            <span>
                                                                To ensure that no accounts have fraudulently been opened in your name
                                                            </span>
                                                        </p>
                                                        <p class="mb-0 text-start text-lg">
                                                            <img height="16px" width="20px" class="me-2" ngOptimizedImage src="../../assets/images/green-check-icon.png">To
                                                            check for faulty entries on
                                                            your credit record
                                                        </p>
                                                        <p class="mb-0 text-start text-lg"><img height="16px" width="20px" class="me-2" ngOptimizedImage
                                                                src="../../assets/images/green-check-icon.png">To check if your are behind on any payments
                                                        </p>
                                                    </ng-template>
                                                </div>
                                            </div>
                                        </div>
                        
                                        <div ngbAccordionItem #parentItem2="ngbAccordionItem" class="mt-3">
                                            <span ngbAccordionHeader id="">
                                                <button type="button"  (click)="parentItem2.toggle()" class="accordion-button custom-header"
                                                    [attr.aria-expanded]="!parentItem2.collapsed" id=""> <span class="question-mark-icon me-2">
                                                        <img ngOptimizedImage src="../../assets/images/question-mark-icon.svg">
                                                    </span><b>Who uses my credit score and why?</b></button>
                                            </span>
                                            <div ngbAccordionCollapse>
                                                <div ngbAccordionBody>
                                                    <ng-template>
                                                        <p class="mb-0 text-start text-lg">
                                                            Prospective credit providers use your credit score to check your ability to repay
                                                            them. This is based on your credit score, payment history, total debt owed, length
                                                            of time you have had debt and the number of recent credit applications.
                                                        </p>
                                                    </ng-template>
                                                </div>
                                            </div>
                                        </div>
                        
                                        <div ngbAccordionItem #parentItem3="ngbAccordionItem" class="mt-3">
                                            <span ngbAccordionHeader id="">
                                                <button type="button"  (click)="parentItem3.toggle()" class="accordion-button custom-header"
                                                    [attr.aria-expanded]="!parentItem3.collapsed" id=""> <span class="question-mark-icon me-2">
                                                        <img ngOptimizedImage src="../../assets/images/question-mark-icon.svg">
                                                    </span><b>How can I maintain or improve my credit score?</b></button>
                                            </span>
                                            <div ngbAccordionCollapse>
                                                <div ngbAccordionBody>
                                                    <ng-template>
                                                        <p class="mb-0 text-start text-lg">
                                                            To improve a poor credit score, or maintain a good one:
                                                        </p>
                                                        <p class="text-start text-lg"><img height="16px" width="20px" class="me-2" ngOptimizedImage
                                                                src="../../assets/images/green-check-icon.png">Pay your debts on time</p>
                                                        <p class="text-start text-lg"><img height="16px" width="20px" class="me-2" ngOptimizedImage
                                                                src="../../assets/images/green-check-icon.png">Never miss a payment</p>
                                                        <p class="text-start text-lg"><img height="16px" width="20px" class="me-2" ngOptimizedImage
                                                                src="../../assets/images/green-check-icon.png">Pay more than the instalment and
                                                        </p>
                                                        <p class="text-start d-flex align-items-start text-lg"><img height="16" width="20" class="me-2" ngOptimizedImage
                                                            src="../../assets/images/green-check-icon.png">
                                                            <span>
                                                                Use debt only for large items such as a home or car loan
                                                            </span>
                                                        </p>
                                                    </ng-template>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        }

                        </form>

                        <form [formGroup]="registerWithIdnumberForm" (ngSubmit)="registerWithIdNumber()" id="auto-register-form" style="display: none" focusInvalidInput>
                            <h2 class="mx-md-0 pt-md-0 caption bottomline mt-0">Complete your <b class="font-bolder">Registration</b>  </h2>
                            <p class="text-start px-md-0 mt-md-2 mt-0">Please enter your personal details in the fields below.</p>

                            <div *ngIf="errorMsg!=''" class="alert alert-danger mb-0 mt-4" role="alert" [innerHTML]="errorMsg">
                            </div>
                            <div class="login-bg d-flex flex-wrap">

                                <div class="form-group fullwidth d-none">
                                    <div class="form-field">
                                        <input id="FinancialPlannerCode_RegistrationPage_AutoReg" type="tel" class="form-control" placeholder="" formControlName="FinancialPlannerCode"
                                            numeric-field maxlength="8">
                                            <label for="FinancialPlannerCode_RegistrationPage_AutoReg">Financial Planner Code</label>
                                            <div *ngIf="registerWithIdnumberFormControls.FinancialPlannerCode.touched && registerWithIdnumberFormControls.FinancialPlannerCode.errors"
                                                class="invalid-feedback">
                                                <div *ngIf="registerWithIdnumberFormControls.FinancialPlannerCode.errors.minlength">Financial Planner Code  must be 8 digits long
                                                </div>
                                            </div>

                                    </div>
                                </div>

                                <div class="form-group fullwidth  required remove-ng-dirtycolor" *ngIf="!isHidden">
                                    <div class="form-field">
                                        <input id="Email_RegistrationPage_AutoReg" type="text" class="form-control" placeholder="" formControlName="Email">
                                        <label for="Email">Email Address*</label>
                                        <div *ngIf="registerWithIdnumberFormControls.Email.touched && registerWithIdnumberFormControls.Email.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="registerWithIdnumberFormControls.Email.errors.required">Email address is required</div>
                                            <div *ngIf="registerWithIdnumberFormControls.Email.errors?.isValidEmail || registerWithIdnumberFormControls.Email.errors?.email">Please enter a valid email
                                                address</div>

                                        </div>
                                    </div>
                                </div>


                                <div class="form-group fullwidth pwd required remove-ng-dirtycolor">
                                    <div class="form-field">
                                        <input id="Password_RegistrationPage_AutoReg" [type]="changetype?'password':'text'" class="form-control" placeholder=""
                                            formControlName="Password" [(ngModel)]="password"
                                            [closeDelay]="1000" [ngbPopover]="popContent" popoverTitle="Password Requirements" triggers="click:blur focus">
                                            <span class="eyeicon" (click)="viewpass()"><i><img ngOptimizedImage  [src]="visible?'assets/images/eye.png':'assets/images/eyeslash.png'"></i> </span>
                                        <label for="Password">Password*</label>
                                        <app-password-strength-bar *ngIf="password" [passwordToCheck]="password"
                                            [barLabel]="'Password strength:'" class="psb"></app-password-strength-bar>
                                        <div *ngIf="registerWithIdnumberFormControls.Password.touched && registerWithIdnumberFormControls.Password.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="registerWithIdnumberFormControls.Password.errors.required">Password is required</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group fullwidth pwd-confirm align-self-start required remove-ng-dirtycolor">
                                    <div class="form-field">
                                        <input id="ConfirmPassword_RegistrationPage_AutoReg" [type]="changetypec?'password':'text'" class="form-control" placeholder=""
                                            formControlName="ConfirmPassword">
                                            <span class="eyeicon" (click)="viewpassofConfirm()"><i><img ngOptimizedImage  [src]="visiblec?'assets/images/eye.png':'assets/images/eyeslash.png'"></i> </span>
                                        <label for="ConfirmPassword">Confirm Password*</label>
                                        <div *ngIf="registerWithIdnumberFormControls.ConfirmPassword.touched && registerWithIdnumberFormControls.ConfirmPassword.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="registerWithIdnumberFormControls.ConfirmPassword.errors.required">Confirm password is
                                                required</div>
                                            <div *ngIf="registerWithIdnumberFormControls.ConfirmPassword.errors.mustMatch">Password must match</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group fullwidth required form-group-full tc mb-3">
                                    <div class="form-check">
                                        <input class="form-check-input" id="AcceptTerms_AutoReg" type="checkbox" formControlName="AcceptTerms">
                                        <div> * I have read and agree to the <a href="/terms" id="TermsAndConditions_AutoReg" target="_blank">Terms and
                                            Conditions</a> and <a href="https://www.sanlam.com/sanlams-privacy-policy"id="PrivacyPolicy_AutoReg" target="_blank">Privacy Policy</a></div>
                                    </div>
                                    <!--<label class="tc-hld">
                                        <label class="switch">
                                            <input type="checkbox" formControlName="AcceptTerms">
                                            <span class="slider" data-off="No" data-on="Yes"></span>
                                        </label>
                                        <span> I have read and agree to&nbsp;<a href="/terms" target="_blank">Terms and
                                                Conditions</a> and <a href="/policy" target="_blank">Privacy Policy</a></span>
                                    </label>-->
                                    <div class="col-md-12">
                                        <div *ngIf="registerWithIdnumberFormControls.AcceptTerms.touched && registerWithIdnumberFormControls.AcceptTerms.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="registerWithIdnumberFormControls.AcceptTerms.errors.pattern"> Please confirm your acceptance of the terms and conditions.</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group fullwidth w-100 pb-0 mb-3 d-flex align-items-center">

                                    <p class="text-start d-flex align-items-center">

                                        <svg width="24" height="24" viewBox="0 0 12 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.75 6H10.5C11.325 6 12 6.675 12 7.5V15C12 15.825 11.325 16.5 10.5 16.5H1.5C0.675 16.5 0 15.825 0 15V7.5C0 6.675 0.675 6 1.5 6H2.25V4.5C2.25 2.43 3.93 0.75 6 0.75C8.07 0.75 9.75 2.43 9.75 4.5V6ZM6 2.25C4.755 2.25 3.75 3.255 3.75 4.5V6H8.25V4.5C8.25 3.255 7.245 2.25 6 2.25ZM1.5 15V7.5H10.5V15H1.5ZM7.5 11.25C7.5 12.075 6.825 12.75 6 12.75C5.175 12.75 4.5 12.075 4.5 11.25C4.5 10.425 5.175 9.75 6 9.75C6.825 9.75 7.5 10.425 7.5 11.25Z" fill="#0075c9"/>
                                            </svg>

                                        <span class="ps-1 text-blue pt-1">All personal information is secure and confidential.</span>
                                    </p>
                                </div>

                                <div class="form-group fullwidth w-100 pt-0 mb-2 justify-content-between">
                                    <button type="submit" class="btnregister w-100" name="btnRegisterRegisterPage" id="Register_btn_AutoReg">
                                        Register
                                    </button>
                                </div>
                                <div class="form-group fullwidth w-100 pt-3 justify-content-between">
                                    <div class="pt-0 pt-md-0 w-100">
                                        <p class="text-start">Already have an account?
                                        <button type="button" (click)="azureAdlogin(false)" id="Login_AutoReg" name="Body-login" class="login-link">Login</button>
                                    </div>
                                </div>

                                <ng-template #popContent>
                                    Be at least 8 characters <br>
                                    Uppercase and lowercase letter (A,z) <br>
                                    Numeric character (0-9) <br>
                                    Special character (!,%,&#64;,#,etc.)
                                </ng-template>
                            </div>

                            <figure class="m-0 d-block d-md-none">
                              <div class="bgmg text-center position-relative">
                                  <img ngOptimizedImage  [src]="defaultImage" class="ps-md-5" alt="" *ngIf="!imageUrl"/>
                                  <img ngOptimizedImage  [src]="imageUrl" class="ps-md-5" alt="" *ngIf="imageUrl"/>
                              </div>
                          </figure>



                            <div class="whatyouget mt-md-3">

                                <div class="d-flex flex-wrap">
                                    <div class="col-md-11 col-12 px-0 center-align">
                                        <h2 class="mb-3 loginpage-caption bottomline">What <b class="font-bolder">you get</b></h2>
                                        <p class="mt-3 horset">Your credit profile provides access to a unique view of your financial position. A credit management  coach will guide you on your journey to reach your financial goals. You can browse through a range of solutions tailored to suit all your financial needs.</p>
                                    </div>
                                </div>

                            </div>
                        </form>

                        <form [formGroup]="registerForm" (ngSubmit)="register()" id="registerForm" style="display: none" focusInvalidInput>
                            <h2 class="mx-md-0 pt-md-0 caption bottomline mt-0">Complete your  <b class="font-bolder">Registration</b></h2>
                            <p class="text-start px-md-0 mt-md-2 mt-0">Please enter your personal details in the fields below</p>

                            <div *ngIf="errorMsg!=''" class="alert alert-danger mb-0 mt-4" role="alert" [innerHTML]="errorMsg">
                            </div>
                            <div class="login-bg d-flex flex-wrap">

                                <div class="form-group fullwidth required">
                                    <div class="form-field ">
                                        <input id="FirstName_RegistrationPage" type="text" class="form-control" placeholder=""
                                            formControlName="FirstName" name-field-hyphen-space>
                                        <label for="FirstName">First Name *</label>
                                        <div *ngIf="registerFormControls.FirstName.touched && registerFormControls.FirstName.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="registerFormControls.FirstName.errors.required">First name is required</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group fullwidth required">
                                    <div class="form-field">
                                        <input id="Surname_RegistrationPage" type="text" class="form-control" formControlName="Surname" placeholder=""
                                        name-field-with-space>
                                        <label for="Surname">Surname *</label>
                                        <div *ngIf="registerFormControls.Surname.touched && registerFormControls.Surname.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="registerFormControls.Surname.errors.required">Surname is required</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group fullwidth required">
                                    <div class="form-field ">
                                        <input id="PhoneNumber_RegistrationPage" type="tel" class="form-control" placeholder=""
                                            formControlName="PhoneNumber" numeric-field maxlength="10" (keyup)="cellNumberErrorMsg=''">
                                        <label for="PhoneNumber">Cell Phone Number *</label>
                                        <div *ngIf="(registerFormControls.PhoneNumber.touched && registerFormControls.PhoneNumber.errors) || cellNumberErrorMsg"
                                            class="invalid-feedback">
                                            <div *ngIf="registerFormControls.PhoneNumber.errors?.required">Cell phone number is required
                                            </div>
                                            <div *ngIf="registerFormControls.PhoneNumber.errors?.minlength">Cell phone number must be 10
                                                digits long</div>
                                            <div *ngIf="registerFormControls.PhoneNumber.errors?.isValidMobile">Please enter your valid
                                                10 digits cell
                                                phone number</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group fullwidth required">
                                    <div class="form-field">
                                        <input id="Email_RegistrationPage" type="text" class="form-control" placeholder="" formControlName="Email">
                                        <label for="Email">Email Address *</label>
                                        <div *ngIf="registerFormControls.Email.touched && registerFormControls.Email.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="registerFormControls.Email.errors.required">Email address is required</div>
                                            <div *ngIf="registerFormControls.Email.errors?.isValidEmail || registerFormControls.Email.errors?.email">Please enter a valid email
                                                address</div>
                                           </div>
                                    </div>
                                </div>

                                <div class="form-group fullwidth  required">
                                    <div class="form-field gi-hld">
                                        <input id="IdNumber_RegistrationPage" type="tel" class="form-control" placeholder="" formControlName="IdNumber"
                                            numeric-field maxlength="13">
                                        <label for="IdNumber">ID Number *</label>
                                        <div *ngIf="registerFormControls.IdNumber.touched && registerFormControls.IdNumber.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="registerFormControls.IdNumber.errors.required">ID Number is required</div>
                                            <div *ngIf="registerFormControls.IdNumber.errors.minlength">ID Number must be 13 digits long
                                            </div>
                                            <div *ngIf="registerFormControls.IdNumber.errors.isValidIdNumber">Please enter your valid 13
                                                digits South
                                                African ID Number</div>
                                        </div>
                                    </div>

                                </div>


                                <div class="form-group fullwidth d-none">
                                    <div class="form-field">
                                        <input id="FinancialPlannerCode_RegistrationPage" type="tel" class="form-control" placeholder="" formControlName="FinancialPlannerCode"
                                            numeric-field maxlength="8">
                                            <label for="FinancialPlannerCode_RegistrationPage">Financial Planner Code</label>
                                            <div *ngIf="registerFormControls.FinancialPlannerCode.touched && registerFormControls.FinancialPlannerCode.errors"
                                                class="invalid-feedback">
                                                <div *ngIf="registerFormControls.FinancialPlannerCode.errors.minlength">Financial Planner Code  must be 8 digits long
                                                </div>
                                            </div>
                                    </div>
                                </div>
                                
                                <div class="form-group fullwidth">
                                    <p class="text-start m-0">
                                        We use your ID number to pull your credit information from the credit bureau into your personalised credit dashboard.
                                    </p>
                                </div>

                                <div class="form-group fullwidth required">
                                    <div class="form-field">
                                        <input id="Password_RegistrationPage" [type]="changetype?'password':'text'" class="form-control" placeholder=""
                                            formControlName="Password" [(ngModel)]="password"
                                            [closeDelay]="1000" [ngbPopover]="popContent" popoverTitle="Password Requirements" triggers="click:blur focus">
                                            <span class="eyeicon" (click)="viewpass()"><i><img ngOptimizedImage  [src]="visible?'assets/images/eye.png':'assets/images/eyeslash.png'"></i> </span>

                                        <label for="Password">Password *</label>
                                        <app-password-strength-bar *ngIf="password" [passwordToCheck]="password"
                                            [barLabel]="'Password strength:'" class="psb"></app-password-strength-bar>
                                        <div *ngIf="registerFormControls.Password.touched && registerFormControls.Password.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="registerFormControls.Password.errors.required">Password is required</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group fullwidth required confirmpw">
                                    <div class="form-field">
                                        <input id="ConfirmPassword_RegistrationPage" [type]="changetypec?'password':'text'" class="form-control" placeholder=""
                                            formControlName="ConfirmPassword">
                                            <span class="eyeicon" (click)="viewpassofConfirm()"><i><img ngOptimizedImage  [src]="visiblec?'assets/images/eye.png':'assets/images/eyeslash.png'"></i> </span>

                                        <label for="ConfirmPassword">Confirm Password *</label>
                                        <div *ngIf="registerFormControls.ConfirmPassword.touched && registerFormControls.ConfirmPassword.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="registerFormControls.ConfirmPassword.errors.required">Confirm password is
                                                required</div>
                                            <div *ngIf="registerFormControls.ConfirmPassword.errors.mustMatch">Password must match</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group required fullwidth mb-3 form-group-full tc">
                                    <!--<label class="tc-hld">
                                        <label class="switch">
                                            <input type="checkbox" formControlName="AcceptTerms">
                                            <span class="slider" data-off="No" data-on="Yes"></span>
                                        </label>
                                        <span> I have read and agree to&nbsp;<a href="/terms" target="_blank">Terms and
                                                Conditions</a> and <a href="/policy" target="_blank">Privacy Policy</a></span>
                                    </label>-->
                                    <div class="form-check">
                                        <input class="form-check-input" id="AcceptTerms_RegistrationPage" type="checkbox" formControlName="AcceptTerms">
                                        <span>* I accept the <a href="/terms" id="TermsAndConditions_ResgistrationPage" target="_blank">Terms and
                                            Conditions</a>; I give consent and hereby request my credit report.</span>
                                    </div>
                                    <div class="col-12 text-left">
                                        <div *ngIf="registerFormControls.AcceptTerms.touched && registerFormControls.AcceptTerms.errors"

                                            class="invalid-feedback left-0">
                                            <div *ngIf="registerFormControls.AcceptTerms.errors.pattern"> Please confirm your acceptance of the terms and conditions.</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group fullwidth w-100 pb-0 mb-3 d-flex align-items-center">

                                    <p class="text-start d-flex align-items-center m-0">

                                        <svg width="24" height="24" viewBox="0 0 12 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.75 6H10.5C11.325 6 12 6.675 12 7.5V15C12 15.825 11.325 16.5 10.5 16.5H1.5C0.675 16.5 0 15.825 0 15V7.5C0 6.675 0.675 6 1.5 6H2.25V4.5C2.25 2.43 3.93 0.75 6 0.75C8.07 0.75 9.75 2.43 9.75 4.5V6ZM6 2.25C4.755 2.25 3.75 3.255 3.75 4.5V6H8.25V4.5C8.25 3.255 7.245 2.25 6 2.25ZM1.5 15V7.5H10.5V15H1.5ZM7.5 11.25C7.5 12.075 6.825 12.75 6 12.75C5.175 12.75 4.5 12.075 4.5 11.25C4.5 10.425 5.175 9.75 6 9.75C6.825 9.75 7.5 10.425 7.5 11.25Z" fill="#0075c9"/>
                                            </svg>


                                        <span class="ps-1 text-blue pt-1">All personal information is secure and confidential.</span>
                                    </p>
                                </div>

                                <div class="form-group fullwidth w-100 pt-0 mb-2 justify-content-between">
                                    <button type="submit" class="btnregister w-100" name="btnRegisterRegisterPage" id="Register_btn">
                                        Register
                                    </button>
                                </div>
                                <div class="form-group fullwidth w-100 pt-3 justify-content-between">
                                    <div class="pt-0 pt-md-0 w-100">
                                        <p class="text-start">Already have an account?
                                        <button type="button" (click)="azureAdlogin(false)" id="Login_RegistrationPage" name="Body-login" class="login-link">Login</button>
                                    </div>
                                </div>


                                <ng-template #popContent>
                                    Be at least 8 characters <br>
                                    Uppercase and lowercase letter (A,z) <br>
                                    Numeric character (0-9) <br>
                                    Special character (!,%,&#64;,#,etc.)
                                </ng-template>
                            </div>

                            <figure class="m-0 d-block d-md-none">
                              <div class="bgmg position-relative">
                                  <img ngOptimizedImage  [src]="defaultImage" class="ps-md-5" alt="" *ngIf="!imageUrl"/>
                                  <img ngOptimizedImage  [src]="imageUrl" class="ps-md-5" alt="" *ngIf="imageUrl"/>
                              </div>
                          </figure>

                        <img [src]="returnXTrackingUrl" style="display:none;">
                        </form>

                        <form [formGroup]="idNumberFormCampaign" class="previewMessage" id="id-number-campaign-form" *ngIf="showCampaignWithId"   (ngSubmit)="idNumberCheckForCampaign()">
                            <h2 class="mx-md-0 pt-md-0 caption bottomline mt-0">
                                <b class="font-bolder">{{primaryHeading}}</b>

                            {{primaryRemaining}}


                        </h2>
                            <p class="text-start px-md-0 mt-md-2 mt-0"*ngIf="campaignData!=null" [innerHtml]="campaignData.primaryContent">

                                <!-- Provide your 13-digit South African ID number to create a secure login for your FREE Sanlam Credit Dashboard.-->
                                </p>

                            <div *ngIf="errorMsg!=''" class="alert alert-danger mb-0 mt-4" role="alert" [innerHTML]="errorMsg">
                            </div>
                            <div class="login-bg d-flex flex-wrap">

                                <div class="required mb-md-0 col-md-8 col-12 px-0 inputspcemobile">
                                    <div class="form-field">
                                        <input id="IdNumber_Campaign" type="tel" class="form-control" placeholder="" formControlName="IdNumber"
                                            numeric-field maxlength="13">
                                        <label for="IdNumber_Campaign">ID Number</label>
                                        <div *ngIf="idNumberFormCampaignControls.IdNumber.touched && idNumberFormCampaignControls.IdNumber.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="idNumberFormCampaignControls.IdNumber.errors.required">ID Number is required</div>
                                            <div *ngIf="idNumberFormCampaignControls.IdNumber.errors.minlength">ID Number must be 13 digits long
                                            </div>
                                            <div *ngIf="idNumberFormCampaignControls.IdNumber.errors.isValidIdNumber">Please enter your valid 13
                                                digits South
                                                African ID Number</div>
                                        </div>

                                    </div>

                                </div>
                                <div class="col-md-4 col-12 pe-md-0 pe-0 ps-md-3 ps-0 mt-md-0">
                                    <button type="submit" class="btnregister w-100 mb-0"
                                            name="btnRegisterRegisterPage"
                                            #artcileNudge>
                                       {{campaignData.campaignButtonName}}
                                    </button>
                                </div>

                                <div class="form-group w-100 pt-3 ps-0 mb-md-3 mb-0  pt-md-4 justify-content-between">

                                    <div class="pt-0 pt-md-0 w-100">
                                        <p class="text-start">Already have an account?
                                            <button type="button" (click)="azureAdlogin(false)" id="Login_AutoReg" name="Body-login" class="login-link">Login
                                            </button>
                                        </p>

                                    </div>
                                </div>
                                <div class="form-group w-100 p-0">
                                    <div class="text-lg pt-md-0 pt-0">
                                        <p class="text-start"> We use your ID number to pull your credit information from the credit bureau into your personalised credit dashboard.</p>


                                    </div>
                                </div>
                                <div class="form-group fullwidth w-100 pb-0 mb-3 d-flex align-items-center">

                                    <p class="text-start d-flex align-items-center m-0">

                                        <svg width="24" height="24" viewBox="0 0 12 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.75 6H10.5C11.325 6 12 6.675 12 7.5V15C12 15.825 11.325 16.5 10.5 16.5H1.5C0.675 16.5 0 15.825 0 15V7.5C0 6.675 0.675 6 1.5 6H2.25V4.5C2.25 2.43 3.93 0.75 6 0.75C8.07 0.75 9.75 2.43 9.75 4.5V6ZM6 2.25C4.755 2.25 3.75 3.255 3.75 4.5V6H8.25V4.5C8.25 3.255 7.245 2.25 6 2.25ZM1.5 15V7.5H10.5V15H1.5ZM7.5 11.25C7.5 12.075 6.825 12.75 6 12.75C5.175 12.75 4.5 12.075 4.5 11.25C4.5 10.425 5.175 9.75 6 9.75C6.825 9.75 7.5 10.425 7.5 11.25Z" fill="#0075c9"/>
                                            </svg>


                                        <span class="ps-1 text-blue pt-1">All personal information is secure and confidential.</span>
                                    </p>
                                </div>

                            </div>
                            <figure class="m-0 d-block d-md-none">
                              <div class="bgmg position-relative">
                                  <img ngOptimizedImage  [src]="defaultImage" class="ps-md-5" alt="" *ngIf="!imageUrl"/>
                                  <img ngOptimizedImage  [src]="imageUrl" class="ps-md-5" alt="" *ngIf="imageUrl"/>
                              </div>
                            </figure>


                            <div class="whatyouget mt-md-3">

                                <div class="d-flex flex-wrap previewMessage">
                                    <div class="col-md-11 col-12 px-0 center-align" *ngIf="campaignData!=null">
                                        <h2 class="mb-3 loginpage-caption bottomline">
                                            <b class="font-bolder">{{secondaryHeading}}</b>
                                        {{secondaryRemaining}} </h2>
                                            <!-- What <b class="font-bolder">you get</b></h2> -->
                                        <p class="mt-3 horset" [innerHTML]="campaignData.secondaryContent">
                                            <!-- Your credit profile provides access to a unique view of your financial position. A credit management  coach will guide you on your journey to reach your financial goals. You can browse through a range of solutions tailored to suit all your financial needs. -->
                                        </p>
                                    </div>
                                </div>

                            </div>
                        </form>


                        <form [formGroup]="idNumberFormCampaign" id="id-number-campaign-form" *ngIf="showCampaignWithOutId">
                                                    <h2 class="mx-md-0 pt-md-0 caption bottomline mt-0 previewMessage">
                                                        <b class="font-bolder">{{primaryHeading}}</b>

                                                    {{primaryRemaining}}


                                                </h2>
                                                    <p class="text-start px-md-0 mt-md-2 mt-0"*ngIf="campaignData!=null" [innerHtml]="campaignData.primaryContent">

                                                        <!-- Provide your 13-digit South African ID number to create a secure login for your FREE Sanlam Credit Dashboard.-->
                                                        </p>


                                                    <div class="login-bg d-flex flex-wrap">


                                                        <div class="col-md-4 col-12 pe-md-0 pe-0 ps-md-3 ps-0 mt-md-0" *ngIf="campaignData!=null">
                                                            <button type="submit" class="btnregister w-100 mb-0"
                                                                    name="btnRegisterRegisterPage" (click)="functionButton()"
                                                                    #artcileNudge>
                                                            {{campaignData.campaignButtonName}}
                                                            </button>
                                                        </div>

                                                    </div>
                                                    <figure class="m-0 d-block d-md-none">
                                                      <div class="bgmg position-relative">
                                                          <img ngOptimizedImage  [src]="defaultImage" class="ps-md-5" alt="" *ngIf="!imageUrl"/>
                                                          <img ngOptimizedImage  [src]="campaignData.imageUrl" class="ps-md-5" alt="" *ngIf="imageUrl"/>
                                                      </div>
                                                  </figure>



                                                    <div class="whatyouget mt-md-3">

                                                        <div class="d-flex flex-wrap previewMessage">
                                                            <div class="col-md-11 col-12 px-0 center-align" *ngIf="campaignData!=null">
                                                                <h2 class="mb-3 loginpage-caption bottomline">
                                                                    <b class="font-bolder">{{secondaryHeading}}</b>
                                                                {{secondaryRemaining}} </h2>
                                                                    <!-- What <b class="font-bolder">you get</b></h2> -->
                                                                <p class="mt-3 horset" [innerHTML]="campaignData.secondaryContent">
                                                                    <!-- Your credit profile provides access to a unique view of your financial position. A credit management  coach will guide you on your journey to reach your financial goals. You can browse through a range of solutions tailored to suit all your financial needs. -->
                                                                </p>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </form>

                        <form [formGroup]="idNumberFormSecondCampaign" id="id-number-campaign-form" *ngIf="campaignSecondCheck"  class="previewMessage" (ngSubmit)="idNumberCheckForSecondCampaign()">
                            <h2 class="mx-md-0 pt-md-0 caption bottomline mt-0">
                                <b class="font-bolder">{{primaryHeadingSecondPage}}</b>

                            {{primarySeondaryRemaining}}


                        </h2>
                            <p class="text-start px-md-0 mt-md-2 mt-0"*ngIf="campaignData!=null" [innerHtml]="campaignData.primaryContentSecondPage">

                                <!-- Provide your 13-digit South African ID number to create a secure login for your FREE Sanlam Credit Dashboard.-->
                                </p>

                            <div *ngIf="errorMsg!=''" class="alert alert-danger mb-0 mt-4" role="alert" [innerHTML]="errorMsg">
                            </div>
                            <div class="login-bg d-flex flex-wrap">

                                <div class="required mb-md-0 col-md-8 col-12 px-0 inputspcemobile">
                                    <div class="form-field">
                                        <input id="IdNumber_SecondCampaign" type="tel" class="form-control" placeholder="" formControlName="IdNumber"
                                            numeric-field maxlength="13">
                                        <label for="IdNumber_SecondCampaign">ID Number</label>
                                        <div *ngIf="idNumberFormSecondCampaignControls.IdNumber.touched && idNumberFormSecondCampaignControls.IdNumber.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="idNumberFormSecondCampaignControls.IdNumber.errors.required">ID Number is required</div>
                                            <div *ngIf="idNumberFormSecondCampaignControls.IdNumber.errors.minlength">ID Number must be 13 digits long
                                            </div>
                                            <div *ngIf="idNumberFormSecondCampaignControls.IdNumber.errors.isValidIdNumber">Please enter your valid 13
                                                digits South
                                                African ID Number</div>
                                        </div>

                                    </div>

                                </div>
                                <div class="col-md-4 col-12 pe-md-0 pe-0 ps-md-3 ps-0 mt-md-0">
                                    <button type="submit" class="btnregister w-100 mb-0"
                                            name="btnRegisterRegisterPage"
                                            #artcileNudge>
                                       {{campaignData.campaignButtonNameSecondPage}}
                                    </button>
                                </div>

                                <div class="form-group w-100 pt-3 ps-0 mb-md-3 mb-0  pt-md-4 justify-content-between">

                                    <div class="pt-0 pt-md-0 w-100">
                                        <p class="text-start">Already have an account?
                                            <button type="button" (click)="azureAdlogin(false)" id="Login_AutoReg" name="Body-login" class="login-link">Login
                                            </button>
                                        </p>

                                    </div>
                                </div>
                                <div class="form-group w-100 p-0">
                                    <div class="text-lg pt-md-0 pt-0">
                                        <p class="text-start"> We use your ID number to pull your credit information from the credit bureau into your personalised credit dashboard.</p>


                                    </div>
                                </div>
                                <div class="form-group fullwidth w-100 pb-0 mb-3 d-flex align-items-center">

                                    <p class="text-start d-flex align-items-center m-0">

                                        <svg width="24" height="24" viewBox="0 0 12 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.75 6H10.5C11.325 6 12 6.675 12 7.5V15C12 15.825 11.325 16.5 10.5 16.5H1.5C0.675 16.5 0 15.825 0 15V7.5C0 6.675 0.675 6 1.5 6H2.25V4.5C2.25 2.43 3.93 0.75 6 0.75C8.07 0.75 9.75 2.43 9.75 4.5V6ZM6 2.25C4.755 2.25 3.75 3.255 3.75 4.5V6H8.25V4.5C8.25 3.255 7.245 2.25 6 2.25ZM1.5 15V7.5H10.5V15H1.5ZM7.5 11.25C7.5 12.075 6.825 12.75 6 12.75C5.175 12.75 4.5 12.075 4.5 11.25C4.5 10.425 5.175 9.75 6 9.75C6.825 9.75 7.5 10.425 7.5 11.25Z" fill="#0075c9"/>
                                            </svg>


                                        <span class="ps-1 text-blue pt-1">All personal information is secure and confidential.</span>
                                    </p>
                                </div>

                            </div>
                            <figure class="m-0 d-block d-md-none">
                              <div class="bgmg position-relative">
                                  <img ngOptimizedImage  [src]="defaultImage" class="ps-md-5" alt="" *ngIf="!imageUrl"/>
                                  <img ngOptimizedImage  [src]="imageUrl" class="ps-md-5" alt="" *ngIf="imageUrl"/>
                              </div>
                            </figure>

                            <div class="whatyouget mt-md-3">

                                <div class="d-flex flex-wrap previewMessage">
                                    <div class="col-md-11 col-12 px-0 center-align" *ngIf="campaignData!=null">
                                        <h2 class="mb-3 loginpage-caption bottomline">
                                            <b class="font-bolder">{{secondaryHeading}}</b>
                                        {{secondaryRemaining}} </h2>                                        
                                            <!-- What <b class="font-bolder">you get</b></h2> -->
                                        <p class="mt-3 horset" [innerHTML]="campaignData.secondaryContent">
                                            <!-- Your credit profile provides access to a unique view of your financial position. A credit management  coach will guide you on your journey to reach your financial goals. You can browse through a range of solutions tailored to suit all your financial needs. -->
                                        </p>
                                    </div>
                                </div>

                            </div>
                        </form>


                    </div>

                    <div class="col-lg-6 col-md-5 d-flex flex-wrap pt-lg-3 ps-lg-5 ps-3 pe-lg-3 pe-3 boxblue align-items-stretch">
                       <app-need-help [isDesktop]="isDesktop()" [imageSrc]="imageUrl || defaultImage"></app-need-help>
                    </div>
                </div>




                <a id="documentPdfAssociate" [attr.data-documentPdfAssociate-id]="documentPdfAssociateId" name="trackIntermediaryUserAssociateRegister"></a>
        </div>

        <div class="login-hld" *ngIf="signupSuccess" style="height: 200px;">
            <h2>
                Registration Successful, <a href="javascript:void(0)" (click)="azureAdlogin(false)">click here to login</a>
            </h2>
        </div>
        <!-- REG HTML Start -->
    </div>

    <ng-template #otpModel let-modal>
        <div class="modal-header">
            <h4 class="modal-title ftsz" id="modal-title-register-otp">
                {{ otpPopupHeaderText }}
            </h4>
            <button name="btnCloseOTPModelRegisterPage" type="button" class="close" aria-label="Close"
                (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <form class="otp-form" [formGroup]="otpForm" (ngSubmit)="validateOtp()">
            <div class="modal-body">
                <div *ngIf="otpErrorMsg!=''" class="alert alert-danger" role="alert">
                    {{otpErrorMsg}}
                </div>
                <div *ngIf="successMsg!=''" class="alert alert-success" role="alert">
                    {{successMsg}}
                </div>

                <div class="form-group fullwidth">
                    <div class="form-field non-editable cellnumber">
                        <input type="text" class="form-control" value="{{registerFormControls.PhoneNumber.value}}"
                            readonly="readonly">
                        <label for="otp">Your Cell Number</label>
                    </div>
                </div>


                <div *ngIf="isOtpSent" class="form-group fullwidth">
                    <div class="form-field">
                        <input type="text" class="form-control" formControlName="Otp" numeric-field maxlength="4">
                        <label for="otp">Please Enter OTP</label>
                        <div *ngIf="otpFormControls.Otp.touched && otpFormControls.Otp.errors" class="invalid-feedback">
                            <div *ngIf="otpFormControls.Otp.errors.required">OTP is required</div>
                            <div *ngIf="otpFormControls.Otp.errors.minlength">OTP must be 4 digits</div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="modal-footer">
                <div class="arrangebtn">
                <button [name]="'btn'+sendOtpText+'OTPRegisterPage'" type="button" ngbAutofocus
                    [ngClass]="(sendOtpText=='Resend SMS OTP')?'btnresndsecond':'btnresend'"
                    (click)="sendOtp(1)">{{sendOtpText}}</button>
                </div>
                <div class="submitbt">
                    <button name="btnSubmitOTPRegisterPage" [disabled]="btnOTPIsDisabled" type="submit" class="btns"
                    *ngIf="isOtpSent">Submit</button>
                </div>

            </div>
        </form>
    </ng-template>

    <ng-template #captureIncomeModel let-modal>
        <div class="modal-header">
            <h4 class="modal-title" id="modal-title-register-income">Enter Your Take Home Salary</h4>
            <button name="btntCloseTakeHomeSalaryModelRegisterPage" type="button" class="close" aria-label="Close"
                (click)="openLandingHomePage()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <form class="capture-income-form" [formGroup]="captureIncomeForm" (ngSubmit)="updateIncome()">
            <div class="modal-body">
                <div *ngIf="captureIncomeErrorMsg!=''" class="alert alert-danger" role="alert">
                    {{captureIncomeErrorMsg}}
                </div>
                <div class="form-group fullwidth">
                    <div class="form-field  gi-hld">
                        <input class="form-control" type="text" appCurrencyMask placeholder="R 20,000"
                            formControlName="GrossIncome" id="currency-number" (blur)="changeGrossIncome()">
                        <label for="GrossIncome">Take Home Salary</label>
                        <div *ngIf="captureIncomeFormControls.GrossIncome.touched && captureIncomeFormControls.GrossIncome.errors"
                            class="invalid-feedback">
                            <div *ngIf="captureIncomeFormControls.GrossIncome.errors.required">Take Home Salary is
                                required</div>
                            <div *ngIf="captureIncomeFormControls.GrossIncome.errors.min">Invalid Take Home Salary</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button name="btntSkipTakeHomeSalaryRegisterPage" type="button" class="btn"
                    (click)="openLandingHomePage()">Skip</button>
                <button name="btntSubmitTakeHomeSalaryRegisterPage" type="submit" class="btn-border">Submit</button>
            </div>
        </form>
    </ng-template>


</section>
<!-- Banner HTML End -->



<!-- Footer HTML Start -->
<footer class="footer-hld">
    <div class="container">
      <div class="d-flex align-items-center flex-wrap footercontainer">
        <div class="col-md-2 mb-md-0 mb-3 footlogo  px-3">


            <svg width="130" height="28" viewBox="0 0 130 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M55.0567 14.5036H50.816C50.7854 13.5247 51.0822 12.7236 51.4581 12.1039C52.524 9.78959 56.2298 9.21101 57.9495 9.21101C60.1586 9.18471 61.8724 9.66028 62.4532 9.90135C64.7412 10.7166 65.1817 12.849 65.1159 13.8133C65.105 16.3226 65.0896 21.6569 65.1159 22.9192C65.1422 24.1815 65.4556 25.1108 65.609 25.4176H65.5926H61.2369C61.0791 25.4176 60.9958 24.4533 60.9739 23.9712H60.9081C59.8299 25.2598 57.4126 25.7573 56.3387 25.8449C55.4512 25.8888 53.3801 25.7792 52.1967 24.9902C50.7174 24.004 50.29 22.9521 50.29 20.8811C50.29 18.81 51.7693 17.5937 52.3939 17.2321C53.0185 16.8705 54.9581 16.3117 56.6675 16.1802C58.035 16.075 58.9686 15.8733 59.2645 15.7857C60.5268 15.5753 60.7766 14.6242 60.7438 14.1749C60.7438 13.9448 61.0068 12.1367 57.9495 12.1039C55.5038 12.0776 55.0019 13.6927 55.0567 14.5036Z" fill="#0074C9"/>
                <path d="M57.884 18.5469C55.0437 18.8625 54.509 20.3221 54.5966 21.0124C54.5966 22.8534 56.5581 23.0835 57.5388 22.9684C59.2877 22.758 60.1961 21.6644 60.4316 21.1439C60.7472 20.6311 60.7494 18.6839 60.7111 17.7744C60.2771 18.3267 58.6455 18.5195 57.884 18.5469Z" fill="white"/>
                <path d="M93.6895 14.5378H89.4488C89.4182 13.5588 89.715 12.7578 90.0909 12.138C91.1568 9.82377 94.8627 9.24519 96.5823 9.24519C98.7914 9.21889 100.505 9.69446 101.086 9.93553C103.374 10.7508 103.814 12.8832 103.749 13.8475C103.738 16.3568 103.722 21.691 103.749 22.9534C103.775 24.2157 104.088 25.1449 104.242 25.4518H104.225H99.8697C99.7119 25.4518 99.6286 24.4875 99.6067 24.0053H99.541C98.4627 25.294 96.0454 25.7915 94.9716 25.8791C94.084 25.9229 92.0129 25.8134 90.8295 25.0244C89.3502 24.0382 88.9229 22.9863 88.9229 20.9152C88.9229 18.8442 90.4022 17.6279 91.0267 17.2663C91.6513 16.9047 93.5909 16.3458 95.3003 16.2143C96.6678 16.1091 97.6014 15.9075 97.8973 15.8199C99.1596 15.6095 99.4095 14.6583 99.3766 14.2091C99.3766 13.979 99.6396 12.1709 96.5823 12.138C94.1366 12.1117 93.6347 13.7269 93.6895 14.5378Z" fill="#0074C9"/>
                <path d="M96.5158 18.5821C93.6755 18.8977 93.1408 20.3573 93.2285 21.0476C93.2285 22.8885 95.1899 23.1186 96.1706 23.0036C97.9195 22.7932 98.8279 21.6996 99.0635 21.1791C99.3791 20.6663 99.3813 18.7191 99.3429 17.8096C98.909 18.3618 97.2774 18.5547 96.5158 18.5821Z" fill="white"/>
                <path d="M1.14437 13.9781L11.0721 0.5C11.1379 0.565747 11.3154 0.815584 11.4995 1.28896C11.7296 1.88068 11.4995 3.12987 11.2694 3.72159C11.0393 4.31331 8.63951 8.25812 7.22596 10.5264C6.09511 12.341 6.75477 14.5698 7.22596 15.4574C7.98204 16.8709 9.29698 17.9886 10.5462 19.0406C11.5455 19.8821 11.7077 21.1664 11.6639 21.7033V27.9493H6.99584C5.60201 27.9493 5.23164 26.8973 5.22068 26.3713V23.5114C5.22068 22.9854 4.97961 22.1088 4.85907 21.7362C3.79616 20.0049 1.55857 16.3581 1.11149 15.6218C0.664414 14.8854 0.947125 14.2192 1.14437 13.9781Z" fill="#0074C9"/>
                <path d="M23.5617 13.9781L13.6339 0.5C13.5682 0.565747 13.3907 0.815584 13.2066 1.28896C12.9764 1.88068 13.2066 3.12987 13.4367 3.72159C13.6668 4.31331 16.0665 8.25812 17.4801 10.5264C18.6109 12.341 17.9513 14.5698 17.4801 15.4574C16.724 16.8709 15.4091 17.9886 14.1599 19.0406C13.1605 19.8821 12.9984 21.1664 13.0422 21.7033V27.9493H17.7102C19.104 27.9493 19.4744 26.8973 19.4854 26.3713V23.5114C19.4854 22.9854 19.7264 22.1088 19.847 21.7362C20.9099 20.0049 23.1475 16.3581 23.5946 15.6218C24.0416 14.8854 23.7589 14.2192 23.5617 13.9781Z" fill="#0074C9"/>
                <ellipse cx="12.3536" cy="12.8285" rx="4.5694" ry="4.53653" fill="#0074C9"/>
                <path d="M83.2451 25.4181V3.62305H87.6173V25.4181H83.2451Z" fill="#0074C9"/>
                <path d="M66.792 25.418V9.67169L70.9176 9.65524V11.8249H71.0162C72.318 9.55004 74.8898 9.12379 76.013 9.19502C80.7862 8.98464 81.7275 13.2385 81.6014 15.3917V25.418H77.2786V16.5751C77.1635 16.1642 77.8868 12.6467 74.4186 12.6467C71.6441 12.6467 71.071 15.2109 71.1313 16.4929V25.418H66.792Z" fill="#0074C9"/>
                <path d="M105.353 25.4673V9.67161L109.511 9.67162V11.7755C109.774 11.7262 110.514 9.27714 114.311 9.24426C117.348 9.21796 118.677 10.9317 118.962 11.7919C120.593 9.55654 122.863 9.16207 123.795 9.24426C128.476 9.11277 129.547 12.6631 129.498 14.4547V25.4673H125.142V15.8847C125.142 15.8847 125.586 12.6302 122.447 12.6302C120.171 12.6302 119.603 14.7725 119.603 15.8847V25.4673H115.198V15.7368V15.7199C115.198 14.6306 115.198 12.5779 112.7 12.6302C110.188 12.6828 109.648 14.7232 109.692 15.7368V25.4673H105.353Z" fill="#0074C9"/>
                <path d="M44.2734 11.6439H44.3114C44.2925 11.5484 44.1792 11.2428 43.8461 10.4933C43.3201 9.3099 41.2162 9.05787 40.23 9.07979C39.1781 9.025 37.0413 9.34277 36.9098 11.0522C36.7783 12.7616 39.9013 13.6054 41.4792 13.8136C46.6075 14.7669 47.5608 15.8517 48.3498 16.6407C49.1387 17.4296 49.6976 19.928 48.8757 21.999C48.0539 24.07 45.687 25.648 40.9861 25.9438C37.2254 26.1805 34.7511 24.5084 33.9841 23.6427C32.5903 22.433 32.2637 20.2677 32.2747 19.3363H36.5153C36.5942 21.4139 38.3234 22.2839 39.1781 22.4593C40.4054 22.7003 43.1821 22.8669 44.4707 21.6045C45.7593 20.3422 44.8542 19.0185 44.2406 18.5144C43.9009 18.2405 42.4063 17.548 39.1452 16.9694C35.8842 16.3908 34.3019 15.2162 33.9183 14.7011C32.2878 12.7287 32.6691 10.2413 33.0636 9.24417C33.6334 7.91827 36.1603 5.37168 41.7093 5.79246C47.2583 6.21324 48.6456 9.86876 48.6456 11.6439H44.3114C44.3223 11.6992 44.3016 11.6841 44.2734 11.6439Z" fill="#0074C9"/>
                </svg>


        </div>
        <div class="col-md-10 ps-md-0">
          <p class=" text-start">Copyright © {{currentYear}} | All rights reserved.Sanlam Life Insurance Limited is a Licensed Financial Services Provider and a Registered Credit Provider.</p>

        </div>

      </div>
    </div>
  </footer>
<!-- Footer HTML End -->
